import * as Mahjong from "@ravalmatic/mahjong-engine";

export class AchievementsManager {

    public static init(): void {
        //
    }

    public static onGameStarted(): void {
        //
    }

    public static onMatch(tileA: Mahjong.TileData, tileB: Mahjong.TileData): void {
        //
    }

    public static onLevelCompleted(levelUnlocked: boolean): void {
        //
    }
}
